import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Alert,
  Grid, Tab,
} from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { useLocation } from 'react-router-dom';
import { CommandPanels, withBaseEditor } from '../../BaseEditor';
import TPs from './tp';
import api from '../../../api/req';
import { AppContext } from '../../../providers/authProvider';
import Loader from '../../../components/MaterialUI/loader';

function EditorRenderer({
  getControl,
  data,
  dataSetter,
  fields,
}) {
  const { auth } = useContext(AppContext);
  const [tab, setTab] = useState('general');
  const [err, setErr] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.includes('create')) {
      const payerId = pathname.slice(pathname.search('create') + 7);

      const person = async () => {
        setErr(null);
        setIsLoading(true);

        const r = await api.get$(`/api/catalog/payers/${payerId}/get_id_person/`, auth);
        if (r.ok) {
          const d = await r.json();
          dataSetter({
            payer: d.payer,
            sex: d.sex,
            name: d.name,
            code: d.code,
            region: d.region,
            date_of_birth: d.date_of_birth,
          });
          setIsLoading(false);
        } else {
          setErr(setErr);
          setIsLoading(false);
        }
      };
      person();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <TabContext value={tab}>
      <TabList onChange={(e, v) => setTab(v)} textColor="primary" indicatorColor="primary">
        <Tab value="general" label="Загальне" />
        <Tab value="historyName" label="Історія зміни прізвища та імені" />
      </TabList>
      {err && (
      <Alert severity="error">
        {err}
      </Alert>
      )}
      {isLoading && (
      <Loader text="Завантаження" />
      )}
      <TabPanel value="general">
        <Grid container spacing={2}>
          <Grid item sm={4}>
            {getControl('name')}
          </Grid>

          <Grid item sm={2}>
            {getControl('date_of_birth')}
          </Grid>

          <Grid item sm={6}>
            {getControl('number')}
          </Grid>

          <Grid item sm={4}>
            {getControl('payer')}
          </Grid>
          <Grid item sm={8}>
            {getControl('code')}
          </Grid>

          <Grid item sm={3}>
            {getControl('sex')}
          </Grid>
          <Grid item sm={3}>
            {getControl('family_status')}
          </Grid>
          <Grid item sm={3}>
            {getControl('education_level')}
          </Grid>

          <Grid item sm={3}>
            {getControl('nationality')}
          </Grid>
          <Grid item sm={4}>
            {getControl('work_company')}
          </Grid>
          <Grid item sm={4}>
            {getControl('work_name')}
          </Grid>
          <Grid item sm={4}>
            {getControl('work_type')}
          </Grid>
          <>
            <Grid item sm={4}>
              {getControl('businessman')}
            </Grid>
            <Grid item sm={4}>
              {getControl('need_social_help')}
            </Grid>
            <Grid item sm={4}>
              {getControl('no_moving')}
            </Grid>
          </>

          <Grid item sm={6}>
            {getControl('region')}
          </Grid>

        </Grid>
      </TabPanel>
      <TabPanel value="historyName">
        <TPs.HistoryNameTP
          data={data.fullnamehistory_set}
          options={fields.fullnamehistory_set}
          onChange={(e, newRecs) => dataSetter({ fullnamehistory_set: newRecs })}
        />
      </TabPanel>
    </TabContext>
  );
}

EditorRenderer.propTypes = {
  getControl: PropTypes.func.isRequired,
  dataSetter: PropTypes.func.isRequired,
  erroredFields: PropTypes.shape({
    full_name: PropTypes.arrayOf(PropTypes.string),
    address: PropTypes.arrayOf(PropTypes.string),
    fullnamehistory_set: PropTypes.arrayOf(PropTypes.string),
  }),
  fields: PropTypes.shape({
    full_name: PropTypes.shape({
      label: PropTypes.string,
    }),
    address: PropTypes.shape({
      label: PropTypes.string,
    }),
    fullnamehistory_set: PropTypes.shape({
      label: PropTypes.string,
    }),
  }).isRequired,

  data: PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.oneOf([1, 2, 3]),
    locality: PropTypes.shape({
      id: PropTypes.number,
      koatuu: PropTypes.string,
    }),
    locality_area: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    street: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    house: PropTypes.shape({
      id: PropTypes.number,
      repr: PropTypes.string,
    }),
    number: PropTypes.string,
    address: PropTypes.string,
    fullnamehistory_set: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

EditorRenderer.defaultProps = {
  erroredFields: {
  },
};

export default withBaseEditor(EditorRenderer, '/api/household/members/', CommandPanels.catCommandPanel);
